import React, { useRef } from 'react';
import Header from '../componentes/Header';
import Inicio from '../componentes/Inicio';
import BtnContactWhatsAppFloating from '../componentes/BtnContactWhatsAppFloating';
import NuestrosProductos from '../componentes/NuestrosProductos';
import PreguntasFrecuentes from '../componentes/PreguntasFrecuentes';
import ShowRoom from '../componentes/ShowRoom';
import Contactanos from '../componentes/Contactanos';
import Footer from '../componentes/Footer';

const PaginaDeInicio = () => {
    const nuestrosProductosRef = useRef(null);
    return ( 
        <>
            <Header />
            <BtnContactWhatsAppFloating />
            <Inicio scrollToProductos={nuestrosProductosRef}/>
            <NuestrosProductos  ref={nuestrosProductosRef}/>
            <PreguntasFrecuentes />
            <ShowRoom />
            <Contactanos />
            <Footer />
        </>
     );
}
 
export default PaginaDeInicio;